module.exports = __webpack_public_path__ + "img/card-emtenan-1.10f8ff33.jpg";